import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=22cd444c&scoped=true&"
import script from "./jobDetails.vue?vue&type=script&lang=js&"
export * from "./jobDetails.vue?vue&type=script&lang=js&"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=22cd444c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd444c",
  null
  
)

export default component.exports